import { defineStore } from 'pinia'
import { api } from '@/lib/api'

// Feature flags resolved per organization (defaults + system-admin
// overrides). The UI hides what's off; the API enforces it independently.
export const useFeaturesStore = defineStore('features', {
  state: () => ({
    flags: {} as Record<string, boolean>,
    platformAdmin: false,
    loadedOrg: null as string | null,
  }),
  getters: {
    // Unknown flags default to enabled — a UI that hasn't loaded yet must
    // never hide working features.
    enabled: (state) => (key: string) => state.flags[key] !== false,
  },
  actions: {
    async load(orgId: string) {
      if (!orgId || this.loadedOrg === orgId) return
      try {
        const res = await api.getFeatures()
        this.flags = res.features
        this.platformAdmin = res.platform_admin
        this.loadedOrg = orgId
      } catch {
        // leave defaults (everything enabled)
      }
    },
    reset() {
      this.flags = {}
      this.loadedOrg = null
    },
  },
})
